import React from 'react';
import { Spin } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

/** دکمه‌های تأیید/لغو ویرایش سریع — فشرده و وسط‌چین */
const InlineEditActions = ({ onSave, onCancel, saving = false }) => (
  <div className="inline-edit-actions" role="group" aria-label="تأیید یا لغو ویرایش">
    <button
      type="button"
      className="inline-edit-actions-btn inline-edit-actions-btn--save"
      onClick={onSave}
      disabled={saving}
      aria-label="ذخیره"
    >
      {saving ? <Spin size="small" /> : <CheckOutlined />}
    </button>
    <button
      type="button"
      className="inline-edit-actions-btn inline-edit-actions-btn--cancel"
      onClick={onCancel}
      disabled={saving}
      aria-label="لغو"
    >
      <CloseOutlined />
    </button>
  </div>
);

export default InlineEditActions;
